import { render } from "./Clone.vue?vue&type=template&id=d1170b26"
import script from "./Clone.vue?vue&type=script&lang=js"
export * from "./Clone.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__